// pages/OtherProfile.js
import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import '../css/GiftDetail.css'; // Reutilizamos el mismo CSS por simplicidad

const OtherProfile = () => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [platform, setPlatform] = useState('web');

  // useParams para obtener los nuevos nombres de parámetros
  const { userAlias, token } = useParams();
  const location = useLocation();

  useEffect(() => {
    // Detectar plataforma (mantenemos la lógica de GiftDetail)
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const mobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    setIsMobile(mobile);

    if (/android/i.test(userAgent)) {
      setPlatform('android');
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      setPlatform('ios');
    } else {
      setPlatform('web');
    }

    // Usamos el alias y el token obtenidos de useParams
    if (userAlias && token) {
      validateAndFetchData(userAlias, token);
    } else {
      // Si no hay alias o token, solo mostramos las opciones de descarga
      setLoading(false);
    }
  }, [userAlias, token, location.pathname]);

  const validateAndFetchData = async (alias, token) => {
    try {
      // Llamada al endpoint específico de perfil
      // Ejemplo: const response = await fetch(`/api/profile/${alias}?token=${token}`);
      
      // Simulación de validación de token y obtención de datos
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Simulación: considera el token válido si tiene más de 10 caracteres
      if (token.length < 10) {
        throw new Error('Token inválido');
      }

      // Datos de ejemplo de perfil
      const data = {
        alias: alias,
        name: `@${alias}`,
        description: `Este es el perfil de ${alias}. ¡Síguele para ver sus regalos!`,
        image: 'https://www.iguanagift.com/assets/logo.png', // Imagen de perfil diferente
        //followers: '12k seguidores',
        bio: [
          'Amante de los regalos originales',
          'Disponible en todo el mundo'
        ]
      };

      setProfileData(data);
      updateMetaTags(data);
      setLoading(false);
    } catch (err) {
      console.error('Error validando token o cargando datos del perfil:', err);
      setLoading(false);
    }
  };

  const updateMetaTags = (data) => {
    // Actualizar title
    document.title = data.name;

    // Función auxiliar para actualizar/crear meta tags
    const setMetaTag = (property, content, isProperty = true) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${property}"]`);
      
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, property);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Open Graph tags
    setMetaTag('og:title', data.name);
    setMetaTag('og:description', data.description);
    setMetaTag('og:image', data.image);
    setMetaTag('og:url', window.location.href);
    setMetaTag('og:type', 'profile'); 
    setMetaTag('profile:username', data.alias); // Tag específico

    // Twitter tags
    setMetaTag('twitter:card', 'summary_large_image', false);
    setMetaTag('twitter:title', data.name, false);
    setMetaTag('twitter:description', data.description, false);
    setMetaTag('twitter:image', data.image, false);

    // Meta description
    setMetaTag('description', data.description, false);
  };

  const handleDownload = (type) => {
    const links = {
      ios: 'https://apps.apple.com/iguanagift/id6753006906',
      android: 'https://play.google.com/store/apps/details?id=es.kaps.iguanagift',
    };
    
    if (links[type]) {
      window.open(links[type], '_blank');
    }
  };

  // Contenido para mostrar el perfil
  const ProfileContent = () => (
    <div className="detail-content"> {/* Reutilizamos la clase */}
      {profileData && (
        <>
          <img 
            src={profileData.image} 
            alt={profileData.name}
            className="detail-image" // Reutilizamos la clase
            style={{ borderRadius: '50%', width: '150px', height: '150px' }} // Adaptación visual
          />
          <div className="detail-body">
            <h2 className="detail-title">
              {profileData.name}
            </h2>
            {/* <p className="detail-price">
              {profileData.followers}
            </p> */}
            <p className="detail-description">
              {profileData.description}
            </p>
            <div className="detail-features">
              <h3 className="features-title">
                Acerca de:
              </h3>
              <ul className="features-list">
                {profileData.bio.map((line, index) => (
                  <li key={index} className="feature-item">
                    <span className="feature-check"></span>
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </>
      )}
    </div>
  );

  const LogoContent = () => (
        <img 
            src='/assets/logo.png' 
            alt='IguanaGIFT'
            className="logo"
        />
  );
  
  const AppDownloadSection = () => (
    <div className="download-section">
      <h3 className="download-title">
        Descarga nuestra app
      </h3>
      <p className="download-subtitle">
        Obtén la mejor experiencia con nuestra aplicación móvil
      </p>
      
      {platform === 'web' ? (
        <div className="download-buttons-web">
          <img 
            src="/assets/app-store-badge.svg" 
            alt="Descargar en App Store"
            onClick={() => handleDownload('ios')}
            style={{ cursor: 'pointer', height: '60px' }}
            />

          <img 
            src="/assets/google-play-badge.svg" 
            alt="Descargar en Google Play"
            onClick={() => handleDownload('android')}
            style={{ cursor: 'pointer', height: '60px' }}
            />
          
          <div className="qr-section">
            <p className="qr-text">
              Escanea el código QR con tu móvil
            </p>
            <div className="qr-container">
              <div className="qr-placeholder">
                <img alt='IguanaGIFT' src='/assets/qrcode_IguanaGIFT_QR.png' />
              </div>
            </div>
          </div>
        </div>
      ) : platform === 'ios' ? (
        <img 
            src="/assets/app-store-badge.svg" 
            alt="Descargar en App Store"
            onClick={() => handleDownload('ios')}
            style={{ cursor: 'pointer', height: '60px' }}
            />
      ) : (
        <img 
            src="/assets/google-play-badge.svg" 
            alt="Descargar en Google Play"
            onClick={() => handleDownload('android')}
            style={{ cursor: 'pointer', height: '60px' }}
            />
      )}
    </div>
  );

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-content">
          <div className="loading-spinner"></div>
          <p className="loading-text">Cargando perfil...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      {!isMobile ? (
        // Vista Desktop: Simulación de móvil + App download al lado
        <div className="desktop-layout">
          <div className={`desktop-grid`}>
            {/* Simulación de pantalla móvil - solo si hay profileData */}
            {profileData && (
              <div className="mobile-frame-container">
                <div className="mobile-frame">
                  <div className="mobile-frame-inner">
                    {/* Notch */}
                    <div className="mobile-notch-container">
                      <div className="mobile-notch"></div>
                    </div>
                    {/* Pantalla */}
                    <div className="mobile-screen">
                      <ProfileContent /> {/* USO DE ProfileContent */}
                    </div>
                  </div>
                </div>
              </div>
            )} 
            {!profileData && (
                <LogoContent />
            )} 
            {/* Sección de descarga */}
            <div className={'download-column'}>
              <AppDownloadSection />
            </div>
          </div>
        </div>
      ) : (
        // Vista Mobile: Detail arriba (si existe), descarga abajo
        <div className="mobile-layout">
          {profileData && (
            <div className="mobile-detail-section">
              <ProfileContent /> {/* USO DE ProfileContent */}
            </div>
          )}
          <div className={`mobile-download-section ${!profileData ? 'mobile-download-centered' : ''}`}>
            <div className={!profileData ? 'mobile-download-full' : ''}>
              <AppDownloadSection />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default OtherProfile;